module.exports = __webpack_public_path__ + "efb48c303a14be08a8c6928151622927.svg";